export const TABS = { PURCHASES: 'purchases', SALES: 'sales' } as const;
export type PurchasesAndSalesTab = (typeof TABS)[keyof typeof TABS];

export const Constants = {
  TAG_NAME: 'pop-purchases-and-sales-component',
  COMPONENT_TITLE: 'Top purchases and sales',
  DATA_AS_OF_DROPDOWN_LABEL: 'Data as of',
  DATA_AS_OF_DROPDOWN_ID: 'data-as-of-select',
  PURCHASES_TAB_LABEL: 'Purchases',
  SALES_TAB_LABEL: 'Sales',
  PURCHASES_UNAVAILABLE_MESSAGE: 'Top purchases unavailable',
  SALES_UNAVAILABLE_MESSAGE: 'Top sales unavailable',
} as const;
